module.exports = __webpack_public_path__ + "static/under_construction-be644799bb200ed531342fd52edf6547.svg";